/**
 * TemplateSetting helpers (GET /TemplateSetting/{templateId}).
 * Collection rule: block post-complete edits only when a config row EXISTS
 * + IsActive + IsPostCompleteEditAvailable=false. Otherwise allow.
 */

export const POST_COMPLETE_EDIT_DISABLED_CODE = 'POST_COMPLETE_EDIT_DISABLED'

export const POST_COMPLETE_EDIT_DISABLED_MESSAGE =
    'This template does not allow edits after the inspection is completed.'

const normalizeFlag = (value, defaultValue = false) => {
    if (value === true || value === 1 || value === '1') return true
    if (value === false || value === 0 || value === '0') return false
    if (typeof value === 'string') {
        const normalized = value.trim().toLowerCase()
        if (normalized === 'true') return true
        if (normalized === 'false') return false
    }
    if (value == null) return defaultValue
    return defaultValue
}

export const isPostCompleteEditBlocked = templateSetting => {
    if (!templateSetting) return false
    // Row exists: treat missing IsActive as active (seeded rows always send it).
    const isActive = normalizeFlag(templateSetting.IsActive, true)
    if (!isActive) return false
    // Explicit false/0/'false' blocks reopen/edit after complete.
    return (
        normalizeFlag(templateSetting.IsPostCompleteEditAvailable, true) ===
        false
    )
}

/** Numeric unique_id for TemplateSetting from an audit / inspection payload. */
export const getTemplateSettingIdFromAudit = audit => {
    if (!audit) return null
    const candidates = [
        audit.OriginalTemplateId,
        audit.originalTemplateId,
        audit.TemplateUniqueId,
        audit.templateUniqueId,
    ]
    const match = candidates
        .map(value => Number(value))
        .find(n => Number.isFinite(n) && n > 0)
    return match || null
}

/** Parse POST /Inspection 403 POST_COMPLETE_EDIT_DISABLED response. */
export const parsePostCompleteEditDisabledError = err => {
    const status = err?.status
    const body = err?.error
    const code =
        body?.code ||
        body?.Code ||
        body?.errorCode ||
        body?.ErrorCode ||
        err?.code
    const message =
        body?.message ||
        body?.Message ||
        err?.message ||
        POST_COMPLETE_EDIT_DISABLED_MESSAGE

    const isDisabled =
        status === 403 &&
        (code === POST_COMPLETE_EDIT_DISABLED_CODE ||
            String(message)
                .toLowerCase()
                .includes('does not allow edits after the inspection'))

    return {
        isDisabled,
        message: isDisabled
            ? message || POST_COMPLETE_EDIT_DISABLED_MESSAGE
            : null,
    }
}
